import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "	<div class=\"disclosures-container-shared-home-loans"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"openOnLoad") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":52},"end":{"line":2,"column":91}}})) != null ? stack1 : "")
    + "\">\n\n		<span class=\"row disclosures-toggle-shared-home-loans\">\n		<div class=\"small-12 column\">\n			"
    + container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disclosuresToggle") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":6,"column":3},"end":{"line":6,"column":31}}}))
    + "\n		</div>\n		</span>\n\n		<div class=\"row disclosures-copy-shared-home-loans\" style=\"display: none;\">\n			<div class=\"small-12 medium-12 column\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"disclosures") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n		</div>\n\n	</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " open-on-load";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":15,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/disclosures-toggle-module",
  "version": "2.0.1",
  "id": "disclosuresToggleModule",
  "containerID": "homeLoansDisclosuresToggleModule",
  "moduleName": "home-loans-disclosures-toggle-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "disclosures-toggle-module",
  "data": {
    "init": "disclosuresToggleModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        button
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    button
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class disclosuresToggleModule
 * @extends {Module}
 */
class disclosuresToggleModule extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#disclosuresToggleModule, #disclosuresToggleMortgageModule, #disclosuresToggleRefinanceModule, #disclosuresToggleHomeEquityModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method animateScroll
   * @desc Scroll to disclosure text with animation
   * @returns {void}
   */
  animateScroll() {
    const spa = $('.route-all').length > 0 ? true : false; // eslint-disable-line

    let offset = $('.spa-page-title').outerHeight();
    const sizeSticky = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'large';
    const $topTabNav = $(`#${sizeSticky}-tab-nav .spa-sticky`);
    if ($topTabNav.length > 0) {
      const topNavHeight = $($topTabNav).outerHeight();
      offset += sizeSticky === 'large' && topNavHeight <= 0 ? 60 : topNavHeight;
    }
    const smallOnlyOrMediumUp = this.Store.getData('currentMQ').viewport === 'small' ? 'show-for-small-only' : 'show-for-medium-up';

    // get assumption selctors
    const $assumptionsIntroRateSpa = $('.section-body:not(.hide):not(.route-all) #assumptionsIntroRate');
    const $assumptionsIntroRate = $('#assumptionsIntroRate');

    // is rates fall back visible
    const rtfIsVisible = $('.ratesTableFallbackModule').map(() => $(this).is(':visible')).get();
    let top;
    try {
      // not spa and rates table is visible assumptions link exists then go to that link
      if (!spa && !_.some(rtfIsVisible) && $assumptionsIntroRate.length > 0) {
        top = $assumptionsIntroRate.offset().top; // eslint-disable-line
      } else if (!spa && _.some(rtfIsVisible) && $assumptionsIntroRate.length > 0) {
        // not spa and rates table is not visible and assumption link then go to disclosures toggle
        top = this.$target.offset().top; // eslint-disable-line
      } else if (!spa && !_.some(rtfIsVisible)) {
        // not spa and rates table is visible then go to disclosures link
        top = $(`.rates-table.${smallOnlyOrMediumUp}`).find('.loan-assumptions-disclosures').last().offset().top; // eslint-disable-line
      } else if (!spa && _.some(rtfIsVisible)) {
        // not spa and rates table is not visible then go to disclosures toggle
        top = this.$target.offset().top; // eslint-disable-line
      } else if (spa && !_.some(rtfIsVisible) && $assumptionsIntroRateSpa.length > 0) {
        // spa and rates table is visible and assumptions link there then go to the link
        top = $assumptionsIntroRateSpa.offset().top; // eslint-disable-line
      } else if (spa && _.some(rtfIsVisible) && $assumptionsIntroRateSpa.length > 0) {
        // spa and rates table is not visible and
        // assumptions link there then go to disclosures toggle
        top = $('.section-body:not(.hide):not(.route-all) div.disclosuresToggleModule').offset().top; // eslint-disable-line
      } else if (spa && !_.some(rtfIsVisible)) {
        // spa and rates table is visible then go to  that link
        const elementLookingFor = $('.section-body:not(.hide):not(.route-all)').find(`.rates-table.${smallOnlyOrMediumUp}`).find('.loan-assumptions-disclosures').last();
        top = elementLookingFor.offset().top; // eslint-disable-line
      } else if (spa && _.some(rtfIsVisible)) {
        // spa and rates table is not visible then go to disclosures toggle
        top = $('.section-body:not(.hide):not(.route-all) div.disclosuresToggleModule').last().offset().top; // eslint-disable-line
      } else {
        top = this.$target.offset().top; // eslint-disable-line
      }
    } catch (exception) {
      top = this.$target.offset().top; // eslint-disable-line
    }

    const animation = {
      scrollTop: top - offset
    };
    $('html, body').animate(animation, 1000);

    // slide down and mark image as rotated down or up
    this.$target.find('.disclosures-copy-shared-home-loans').slideDown('slow');
    const $arrow = this.$target.find('.disclosures-toggle-image-shared-home-loans');
    $arrow.removeClass('rotate-down').addClass('rotate-up');

    // triggering a resize about halfway through
    // the animation fixes an issue with scrolling to exact section
    setTimeout(() => {
      $(window).trigger('resize');
    }, 600);
  }

  /**
   * @method updateLinksUrl
   * @desc add query parameters to assumptions link
   * @param {object} response from success subscribe
   * @returns {boolean} returns false if rateInputs are not there in response.data
   */
  updateLinksUrl(response) {
    const rates = response.data;
    if (!rates.rateInputs) {
      return false;
    }
    this.$target.fadeIn();
    const rateInputs = rates && rates.rateInputs;
    const zipcode = rateInputs && rateInputs.postalCode;
    const purchasePrice = rateInputs && rateInputs.purchasePrice;
    const downPayment = rateInputs && rateInputs.downPayment;
    const $links = this.$target.find('.loan-assumptions-links');
    const route = rates && rates.route;
    const url = spaParams.pageParams.assumptions;
    const loanTypeMapping = {
      mortgage: 'mortgage',
      refinance: 'refinance',
      'home-equity': 'homeEquity'
    };
    const loanType = loanTypeMapping[route] || spaParams.pageParams.loanType;
    const matches = window.location.pathname.match(/\/(\w{2}\/)$/);
    const language = matches ? matches[1] : '';
    $links.each(function linksEach() {
      const $link = $(this);
      $link.attr('href', `${url}${language}?purchasePrice=${purchasePrice}&downPayment=${downPayment}&zipcode=${zipcode}&loanType=${loanType}`);
    });
    return true;
  }

  /**
   * @method fadeOutModule
   * @desc fadeout disclosures module if getProductRates call fails
   * @param {object} response from failure subscribe
   * @returns {void}
   */
  fadeOutModule(response) {
    const route = response.data && response.data.route;
    if (route === 'mortgage') {
      $('#disclosuresToggleMortgageModule').fadeOut(1000);
    }
    if (route === 'refinance') {
      $('#disclosuresToggleRefinanceModule').fadeOut(1000);
    }
  }

  /**
   * @method init
   * @desc Initialize module
   * @returns {void}
   */
  init() {
    // don't remove space. it will not find it otherwise
    const $link = this.$target.find('a.disclosures-toggle  ');
    $link.attr('role', 'button');
    const $openOnLoad = this.$target.find('.open-on-load');
    const dropdownToggle = Utility.dropdownToggle(this.$target.find('.disclosures-copy-shared-home-loans'), this.$target.find('.disclosures-toggle-image-shared-home-loans'));
    const dropdownToggleOpen = Utility.dropdownToggle($openOnLoad.find('.disclosures-copy-shared-home-loans'), $openOnLoad.find('.disclosures-toggle-image-shared-home-loans'));
    const open = '<span class="ada-hidden">expanded</span>';
    const close = '<span class="ada-hidden">collapsed</span>';
    const decoratedDropdownToggle = () => {
      dropdownToggle();
      const expanded = $link.attr('aria-expanded') || 'false';
      if (expanded === 'true') {
        $link.attr('aria-expanded', 'false');
        $link.find('.ada-hidden').remove();
        $link.append(close);
      } else {
        $link.attr('aria-expanded', 'true');
        $link.find('.ada-hidden').remove();
        $link.append(open);
      }
    };
    const $disclosuresToggle = this.$target.find('.disclosures-toggle-shared-home-loans');
    $disclosuresToggle.off();
    $disclosuresToggle.on('click', _.debounce(decoratedDropdownToggle, 200));
    const animateScroll = this.animateScroll.bind(this);
    const $daggerLinks = $('a.disclosures-dagger');
    $daggerLinks.off();
    $daggerLinks.on('click', animateScroll);
    if (this.$target.find('.disclosures-container-shared-home-loans').hasClass('open-on-load')) {
      // open disclosure on page load
      dropdownToggleOpen();
      $link.attr('aria-expanded', 'true');
      $link.find('.ada-hidden').remove();
      $link.append(open);
    }
    this.Events.sub('DISCLOSURES_DAGGER_RE_RENDER', response => {
      const $newDaggerLinks = response.data;
      $newDaggerLinks.off();
      $newDaggerLinks.on('click', animateScroll);
    });
    this.updateAssumptionsLink();
    // MORTGAGE OVERVIEW MORTGAGE TAB
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS', this.updateLinksUrl);
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE', this.fadeOutModule);

    // MORTGAGE OVERVIEW REFINANCE TAB
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS', this.updateLinksUrl);
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE', this.fadeOutModule);

    // MORTGAGE PAGE
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.updateLinksUrl);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', Utility.fadeOutModule.bind(this));

    // REFINANCE PAGE
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.updateLinksUrl);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', Utility.fadeOutModule.bind(this));
  }

  /**
   * @method updateAssumptionsLink
   * @desc add query parameters to assumptions link
   * @returns {void}
   */
  updateAssumptionsLink() {
    const $links = this.$target.find('.loan-assumptions-disclosures');
    const url = spaParams.pageParams.assumptions || spaParams.siteParams.assumptionsLink['home-equity'];
    let state = this.Store.getUserSelectedState();
    const matches = window.location.pathname.match(/\/(\w{2}\/)$/);
    const language = matches ? matches[1] : '';
    if (!state) {
      state = spaParams.pageParams.defaultState;
      this.Store.addData('state', state || '');
    }
    $links.attr('href', `${url}${language}?loanType=homeEquity&state=${state}`);
  }
}
registerModuleClass({
  moduleClass: disclosuresToggleModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { disclosuresToggleModule as default, moduleConfig };
